import React from 'react';

import { ILocation, IState } from '@medely/types';
import { Link } from '../Link';
import DisplayHelpers from '../../utils/displayHelpers';

const { cityStateZip } = DisplayHelpers.location;

type AddressLinkProps = {
  location: Pick<ILocation, 'address_first' | 'address_second' | 'address_city' | 'address_zip'> & {
    state: Pick<IState, 'abbreviation'>;
  };
};

export const AddressLink = ({ location }: AddressLinkProps) => {
  const addressSecondString = location.address_second ? `${location.address_second}, ` : '';
  const addressInfo = cityStateZip(
    location.address_city,
    location.state.abbreviation,
    location.address_zip,
  );
  return (
    <Link
      url={`https://maps.google.com/?q=${location.address_first}, ${
        location.address_second ?? ''
      } ${addressInfo}`}
      variant="text"
      size="m"
    >
      {`${location.address_first}, ${addressSecondString}${addressInfo}`}
    </Link>
  );
};
